export const KIWIBANK = 'kiwibank'
